// extracted by mini-css-extract-plugin
export default {"container":"SettingPage_container__-VHd+","list__container":"SettingPage_list__container__1JdaR","emptyMessage":"SettingPage_emptyMessage__jiHl6","title":"SettingPage_title__-f+ZV"};